// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2FJij","detailsBorder":"styles_detailsBorder__1El-5"};